import { Component, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-collapsible-arrow',
  templateUrl: './collapsible-arrow.component.html',
  styleUrls: ['./collapsible-arrow.component.scss']
})
export class CollapsibleArrowComponent {

  @Input()
  public size: 'lg' | 'sm' = 'lg';

  public opened: boolean;
  public toggle = new EventEmitter<void>();

  public triggerToggle(event?: Event) {
    event?.stopImmediatePropagation();
    this.toggle.emit();
  }
}
